<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc" title="Copyright"></h2>
<p class="first" id="Copyright">InterVarsity Press<br/>
  P.O. Box 1400<br/>
  Downers Grove, IL 60515-1426<br/>
  World Wide Web: <a href="http://www.ivpress.com" target="_blank">www.ivpress.com</a><br/>
  E-mail: <a href="mailto:email@ivpress.com">email@ivpress.com</a></p>
<p class="first">© 2012 by Dallas Willard</p>
<p class="first">All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</p>
<p class="first">InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept. InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at <a href="http://www.intervarsity.org" target="_blank">www.intervarsity.org</a>.</p>
<p class="first">Scripture quotations, unless otherwise noted, are from the New Revised Standard Version of the Bible, copyright 1989 by the Division of Christian Education of the National Council of the Churches of Christ in the USA. Used by permission. All rights reserved.</p>
<p class="first"></p>
<p class="first">Cover design by Cindy Kiple<br/>
  Cover photograph: © Odilon Dimier/ZenShui/Corbis/Glow Images</p>
<p class="first">Interior design by Beth Hagenberg</p>
<p class="first">ISBN 978-0-8308-6992-3</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?25d809af